// once we work on the functionality, the selectors will be created here
// sample code

import { createSelector } from 'reselect';
import { initState } from './reducer';

const feeReducer = (state) => state.feeInfo || initState;

const feeData = createSelector(feeReducer, (cnter) => cnter.feeData.feeDetail);
const isFeeLoading = createSelector(feeReducer, (cnter) => cnter.isFeeLoading);

const tosData = createSelector(feeReducer, (cnter) => cnter.tosData);
const getTosLoading = createSelector(feeReducer, (cnter) => cnter.getTosLoading);

export default {
	feeData,
	feeReducer,
	isFeeLoading,
	tosData,
	getTosLoading
};
